'use client';

import React, { HTMLAttributes, useEffect, useRef, useState } from 'react';

import { Locale } from '../../../i18n.config';
import Slider, { Settings } from 'react-slick';

import './styles.css';

interface IMultiCarouselProps extends HTMLAttributes<HTMLDivElement> {
  settings?: Settings;
  items: JSX.Element[];
}

export const MultiCarousel: React.FC<IMultiCarouselProps> = ({
  items,
  settings,
  className,
}) => {
  const [propagationStopped, setPropagationStopped] = useState(false);
  const sliderRef = useRef<HTMLDivElement>(null);
  const itemsAmount = items.length || 0;
  const defaultSettings: Settings = {
    dots: false,
    infinite: true,
    swipe: true,
    speed: 1000,
    arrows: true,
    initialSlide: 0,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    slidesToScroll: 1,
  };

  // const dragStart = (e: MouseEvent | TouchEvent) => {
  //   const slickSlides = document.querySelectorAll('.slick-slide');
  //   setTimeout(() => {
  //     slickSlides.forEach(slide => {
  //       slide.classList.add('pointer-events-none');
  //     });
  //   }, 200)
  // }

  // const dragStop = (e: MouseEvent | TouchEvent) => {
  //   const slickSlides = document.querySelectorAll('.slick-slide');
  //   setTimeout(() => {
  //     slickSlides.forEach(slide => {
  //       slide.classList.remove('pointer-events-none');
  //     });
  //   }, 200)
  // }

  // useEffect(() => {
  //   if (sliderRef.current) {
  //     const slider = sliderRef.current

  //     slider.addEventListener('mousedown', dragStart);
  //     slider.addEventListener('touchstart', dragStart);
  //     slider.addEventListener('mouseup', dragStop);
  //     slider.addEventListener('touchend', dragStop);

  //     return () => {
  //       slider.removeEventListener('mousedown', dragStart);
  //       slider.removeEventListener('touchstart', dragStart);
  //       slider.removeEventListener('mouseup', dragStop);
  //       slider.removeEventListener('touchend', dragStop);
  //     };
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [sliderRef]);

  return (
    <div
      ref={sliderRef}
      className={`carousel-${itemsAmount}-items flex flex-col w-full mx-auto z-10 items-center group`}>
      <div
        className={`
        hidden w-full group is-outside-carousel flex-row desktop:mt-16 h-auto desktop:mb-8 desktop:!m-0 justify-center
        group-[.carousel-0-items]:hidden
        group-[.carousel-2-items]:tablet:flex
        group-[.carousel-3-items]:laptop:flex
        group-[.carousel-4-items]:desktop:flex
      `}>
        {items}
      </div>

      <Slider
        {...{ ...defaultSettings, ...settings }}
        className={`
        tour-carousel
        group-[.carousel-0-items]:hidden 
        group-[.carousel-2-items]:tablet:hidden 
        group-[.carousel-3-items]:laptop:hidden 
        group-[.carousel-4-items]:desktop:hidden
        ${className}
      `}>
        {items}
      </Slider>
    </div>
  );
};
